import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import './src/styles/global.css'
